import { faBiking } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import Button from "../../Components/Button/Button";
import Input from "../../Components/Input/Input";
import Timer from "../../Components/Timer/Timer";
import Style from "./Login.module.css";
import { errorToast, succToast } from "../../Utils/Toast/Toast";
import { useHistory } from "react-router-dom";
import { confirmCodeApi, confirmPhoneApi } from "../../Api/DeliveryBarest";

const ConfirmCode = (props) => {
  const history = useHistory("");
  const [code, setCode] = useState();
  const [resend, setResend] = useState(false);
  
  const [phoneNumber, setPhoneNumber] = useState(props.location.state);
  const [disableOrder, setDisableOrder] = useState(false);
  const [remainTime, setReaminTime] = useState("");

  useEffect(() => {
    getCode();
  }, []);
  const getCode = () => {
    let info = {
      phone: phoneNumber,
    };
    confirmPhoneApi(info, (succ) => {
      if (succ.status === 1) {
        succToast(succ.message);
        setReaminTime(succ.remaining_time);
        setResend(false);
        setPhoneNumber(succ.phone);
        setTimeout(
          () => setResend(true),
          parseInt(`${succ.remaining_time}000`)
        );
      } else if (
        succ.message === "شماره وارد شده اشتباه است!" ||
        succ.message === "حسابی با این شماره یافت نشد!"
      ) {
        errorToast(succ.message);
        setTimeout(() => history.push("./login"), 1000);
      } else {
        errorToast(succ.message);
        setReaminTime(succ.remaining_time);
        setPhoneNumber(succ.phone);
        setTimeout(
          () => setResend(true),
          parseInt(`${succ.remaining_time}000`)
        );
      }
    });
  };
  const CheckCodeHandler = (e) => {
    e.preventDefault();
    setDisableOrder(true)
    if (code === "") errorToast("لطفا کد را وارد کنید!");
    else {
        let info = {
            phone: phoneNumber,
            code: code,
        };
        confirmCodeApi(info, (succ) => {
            if (succ.status === 1) {
                succToast(succ.message);
                localStorage.setItem("JwtTokens", succ.token);
                localStorage.setItem("type", succ.type);
                
                setDisableOrder(false)
                setTimeout(() => history.push("/"));
            } else {
                setDisableOrder(false)
                errorToast(succ.message);
          setPhoneNumber(succ.phone);
          setReaminTime(succ.remaining_time);
          setTimeout(
              () => setResend(true),
              parseInt(`${succ.remaining_time}000`)
              );
        }
      });
    }
  };
  return (
    <div className={Style.pageHolder}>
      <div className={Style.ImageHolder}>
        <img src="./Assets/Images/Auth/food-delivery.jpg" alt="barest" />
      </div>
      <form className={Style.formHolder}>
        <FontAwesomeIcon icon={faBiking} />
        <p>:کد دریافتی را وارد کنید</p>
        <Input
          inputtype={"text"}
          placeholder="کد دریافتی..."
          pattern="\d*"
          maxLength="6"
          style={{ textAlign: "center" }}
          value={code ? code : ""}
          onChange={(e) => setCode(e.target.value)}
        />
        {resend ? (
          <p className={Style.resend} onClick={getCode}>
            ارسال دوباره
          </p>
        ) : (
          <Timer Time={remainTime} />
        )}
        <div className={Style.BtnHolder}>
          <Button
            Value={"تایید"}
            ClassBtn={"confirmBtn"}
            ClickHandler={CheckCodeHandler}
            disabledProps={disableOrder}
          />
        </div>
      </form>
    </div>
  );
};
export default ConfirmCode;
